import { Dispatch, SetStateAction, createContext } from "react";

import { DailyMissionPIN } from "user-dashboard/components/header/Header";

import { DailyMission } from "utils/validations/daily-mission";

export enum UserDailyMissionStatus {
	COMPLETED = "completed",
	IN_PROGRESS = "in_progress",
	LOCKED = "locked",
	EXPIRED = "expired",
}

export type UserDailyMission = {
	_id: string;
	dailyMissionId: DailyMission;
	isCompleted: boolean;
	status: UserDailyMissionStatus;
	expiredAt: string;
	parentDailyMissionId?: string;
};

type UserDailyMissionCtx = {
	loading: boolean;
	setLoading: Dispatch<SetStateAction<boolean>>;
	openReader: boolean;
	setOpenReader: Dispatch<SetStateAction<boolean>>;
	openPIN: boolean;
	setOpenPIN: Dispatch<SetStateAction<boolean>>;
	userDailyMission?: UserDailyMission;
	setUserDailyMission: Dispatch<SetStateAction<UserDailyMission | undefined>>;
	completeMission: (values: DailyMissionPIN) => Promise<void>;
};

export const UserDailyMissionContext = createContext<UserDailyMissionCtx>({
	loading: false,
	setLoading: () => {},
	openReader: false,
	setOpenReader: () => {},
	openPIN: false,
	setOpenPIN: () => {},
	setUserDailyMission: () => {},
	completeMission: async (values: DailyMissionPIN) => {},
});
